import { renderTopLevelComponent } from 'app/scripts/controller/renderTopLevelComponent';
import { WorkspaceBoardsPage } from 'app/src/components/WorkspacePages/WorkspaceBoardsPage';
import { controllerEvents } from './controllerEvents';

export const organizationBoardsPage = async ({
  orgNameOrId,
}: {
  orgNameOrId: string;
}) => {
  controllerEvents.trigger('clearPreviousView', { isNextViewReact: true });
  controllerEvents.trigger('setViewType', 'OrganizationBoardsView');
  renderTopLevelComponent(<WorkspaceBoardsPage orgNameOrId={orgNameOrId} />);
};
